import { AxiosResponse } from 'axios';
import axiosInstance from '../../utils/axios';

import { TagSubmissionData, TagSubmissionResponse } from '../types/tagSubmission.types';

export const submitTagSale = async (
  data: TagSubmissionData
): Promise<AxiosResponse<TagSubmissionResponse>> => {
  const formData = new FormData();
  formData.append('orderNumber', data.orderNumber);
  formData.append('clientName', data.clientName);
  formData.append('deliveryAddress', data.deliveryAddress);
  
  // Append each file to the FormData
  if (data.files) {
    data.files.forEach((file) => {
      formData.append('files', file);
    });
  }

  return axiosInstance.post('/api/v1/tasks/tag-submission', formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
};
